import { ORDER_BUILDER_ROUTES } from '../../constants/order-builder-routes';
import { StepRoute } from '../../models/step-route.model';

export const ThreeStepsWay = [
  {
    name: 'views.builder.product_line',
    route: ORDER_BUILDER_ROUTES.BusinessLine,
  },
  {
    name: 'views.builder.location_and_specifications',
    route: ORDER_BUILDER_ROUTES.LocationAndSpecification,
  },
  {
    name: 'views.builder.summary',
    route: ORDER_BUILDER_ROUTES.BlkSummary,
  },
] as StepRoute[];
